// AncientEgypt.js
import React from "react";
import "./EraPage.css"; // Updated to shared EraPage.css styling

function AncientEgypt() {
  return (
    <div className="era-page">
      <div className="era-banner egyptian-banner">
        <h1>🏺 Ancient Egypt: Land of Pharaohs</h1>
        <p className="era-subtitle">Where sand meets the sacred Nile</p>
      </div>

      {/* Overview */}
      <section className="egyptians-overview">
        <h2>🗺️ Overview</h2>
        <p>
          Ancient Egypt was one of the oldest and most fascinating civilizations in human history.
          Stretching along the Nile River, it lasted for over 3,000 years and left behind incredible pyramids,
          mummies, and hieroglyphs.
        </p>
      </section>

      {/* Key Events & Figures */}
      <section className="egyptians-key">
        <h2>🧠 Key Figures & Events</h2>
        <ul>
          <li><strong>Pharaohs:</strong> Kings like <em>Ramses II</em> and <em>Tutankhamun</em> ruled the land.</li>
          <li><strong>Pyramids:</strong> The Great Pyramid of Giza was built over 4,500 years ago!</li>
          <li><strong>Hieroglyphs:</strong> A system of writing using pictures and symbols.</li>
          <li><strong>The Nile:</strong> The river gave life to Egypt with water, farming, and transportation.</li>
        </ul>
      </section>

      {/* Story or Comic Style Content */}
      <section className="egyptians-story">
        <h2>📜 A Day in the Life of a Young Scribe</h2>
        <p>
          Meet Amun, a 12-year-old learning to write hieroglyphs on papyrus scrolls. 
          He wakes up early to feed the animals, then heads to the temple school where
          he learns math, history, and the sacred symbols. His dream? One day write messages for the Pharaoh himself!
        </p>
      </section>

      {/* Quiz or Challenge */}
      <section className="egyptians-quiz">
        <h2>🎮 Quick Challenge</h2>
        <p><strong>What was the name of the river that gave Egypt life?</strong></p>
        <ul className="quiz-options">
          <li>Amazon River</li>
          <li><strong>The Nile</strong> ✅</li>
          <li>Yellow River</li>
          <li>Mississippi River</li>
        </ul>
      </section>

      {/* Optional Video Embed */}
      <section className="egyptians-media">
        <h2>🎥 Watch & Learn</h2>
        <img
    className="egyptians-illustration"
    src="/images/ancient-egypt-scene.png" // Use your actual path and filename
    alt="Illustration of the Great Pyramid, the Nile, a Pharaoh, a young scribe, and Egyptian symbols"
    style={{ width: "100%", maxWidth: 500, borderRadius: "1.5rem", margin: "0 auto", boxShadow: "0 4px 24px rgba(0,0,0,0.12)" }}
  />
      </section>

      {/* Timeline */}
      <section className="egyptians-timeline">
        <h2>🕰️ Simple Timeline</h2>
        <ul className="timeline">
          <li>c. 3100 BCE - Unification of Upper and Lower Egypt</li>
          <li>c. 2600 BCE - Pyramids of Giza constructed</li>
          <li>c. 1350 BCE - Tutankhamun becomes Pharaoh</li>
          <li>30 BCE - Egypt becomes part of the Roman Empire</li>
        </ul>
      </section>
    </div>
  );
}

export default AncientEgypt;
